import TituloSeccionH2 from '@/components/elements/TituloSeccionH2';
import { LoginDatos } from '@/objects/User';
import { Card } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useEffect } from 'react';
import CheckBoxCustom from '@/components/elements/Checkbox';
import Boton from '@/components/elements/Boton';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import { useServices } from '@/context/ServicesProvider';
import { mostrarAlerta } from '@/context/UtilsContext';
import { refrescarDatosUsuarioLogin } from '@/util/LocalStorageLoaded';
import { subtitulo } from '@/constants/Dimens';
//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface Props {
    datosUsuario: LoginDatos | null;
    setDatosUsuario: React.Dispatch<React.SetStateAction<LoginDatos | null | undefined>>;
}

const DatosAlertas: React.FC<Props> = ({ datosUsuario, setDatosUsuario }) => {

    const { usersQueries } = useServices();

    const [avisos_mensajes, setAvisosMensajes] = React.useState<boolean>(false);

    const { t } = useTranslation();

    useEffect(() => {
        setAvisosMensajes(datosUsuario?.aviso_email_chat! == 1);
    }, [datosUsuario]);


    function guardarDatos() {
        usersQueries?.guardarEmailsChat(datosUsuario?.id_user!, avisos_mensajes ? 1 : 0).then((response) => {
            if (datosUsuario) {
                datosUsuario.aviso_email_chat = avisos_mensajes ? 1 : 0;
                setDatosUsuario(datosUsuario);
            }
            mostrarAlerta({
                title: t('common:opciones.informacion'),
                content: t("menu:secciones.ajustes_perfil.datos_actualizados_correctamente"),
                showCancelButton: false,
            });
            usersQueries?.obtenerDatosUsuario().then((response) => {
                if (response.data) {
                    refrescarDatosUsuarioLogin(response.data);
                }
            }
            );
        });
    }

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: "100%" }}>
            <TituloSeccionH2 fontSize={subtitulo} texto={t("menu:secciones.ajustes_perfil.avisos_email_chat_datos")} />
            <div style={{ display: 'flex', flexDirection: 'column', width: "100%", alignItems: 'center', }}>
                <Card style={{
                    display: 'flex', flexDirection: 'column', justifyContent: 'center',
                    alignItems: 'center', gap: '5px', padding: "20px", width: "100%"
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start", marginBottom: "20px" }}>
                        <CheckBoxCustom idCheck='avisos_mensajes' label={t("menu:secciones.ajustes_perfil.avisos_email_mensajes_chat")} isChecked={avisos_mensajes} onCheckChange={setAvisosMensajes} />
                    </div>
                    <Boton fullWidth startIcon={<BrowserUpdatedIcon />} texto={t("menu:secciones.ajustes_perfil.actualizar_datos")} onClick={() => guardarDatos()} />
                </Card>
            </div>
        </section>
    );
}

export default DatosAlertas;
